module.exports = __webpack_public_path__ + "static/media/cbCal_Terms_And_Conditions.1e226a65.pdf";